module.exports = __webpack_public_path__ + "img/bn_img_one.3311e911.svg";